function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-19.87%",
  y1: "-6.768%",
  x2: "117.594%",
  y2: "100%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "119.936%",
  y1: "0%",
  x2: "0%",
  y2: "84.589%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "137.029%",
  y1: "129.104%",
  x2: "50%",
  y2: "50%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-97.01%",
  y1: "148.218%",
  x2: "65.921%",
  y2: "50%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-160.796%",
  y1: "-224.453%",
  x2: "107.047%",
  y2: "70.702%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEF5FE",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-40 -3)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 324c14.45-54.047 43.71-74.586 87.777-61.617 66.1 19.454 66.1 18.745 111.319-14.078 13.563-9.845 5.124-56.405-15.209-57.93-20.333-1.527-4.806-35.062 30.203-41.642 35.009-6.579-9.4-53.037-36.047-66.539-27.674-14.022 7.874-50.933 10.62-65.03C193.119-5.72 130.232-5.72 0 17.164V324z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415 538c-26.188-.61-45.499-12.592-57.931-35.948-18.649-35.034-18.495-110.797-58.255-106.655-39.76 4.142-82.248-12.803-67.163-60.527 15.085-47.724 50.32-41.809 58.742-119.597 8.421-77.79-60.53 16.148-71.918-35.577-4.447-20.2 6.109-22.922-10.258-45.647-5.433-7.544-8.06-18.476-6.977-22.725C204.606 39.734 206.931 3.626 208.217 3c6.126-2.98 14.416-2 27.55-2 28.276 0 88.02.667 179.233 2v535z",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#c)",
  transform: "rotate(45 83 649)",
  x: 75,
  y: 641,
  width: 16,
  height: 16,
  rx: 1.263
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.025 458.05l8.337 16.673a2.264 2.264 0 0 1-2.025 3.277H86.663a2.264 2.264 0 0 1-2.025-3.277l8.337-16.673a2.264 2.264 0 0 1 4.05 0z",
  stroke: "url(#d)",
  strokeWidth: 4.528,
  opacity: 0.543,
  transform: "rotate(30 95 466)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#e)",
  transform: "rotate(45 265.192 449.02)",
  x: 258.692,
  y: 442.521,
  width: 13,
  height: 13,
  rx: 1
}));

function SvgBgHeroMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 657,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeroMobile);
export default __webpack_public_path__ + "static/media/bg-hero-mobile.fa71e99ae112550574bcc81803454520.svg";
export { ForwardRef as ReactComponent };